









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {RastreamentoHistorico} from '@/model/resource/RastreamentoHistorico'
import {InputRastreamentoHistoricoSchema} from '@/schema/resource/RastreamentoHistorico/InputRastreamentoHistoricoSchema'

@Component
export default class PersistRastreamentoHistoricoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputRastreamentoHistoricoSchema()
  rastreamentoHistorico = new RastreamentoHistorico()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionRastreamento.listRastreamento()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.rastreamentoHistorico.getRastreamentoHistorico(id)
    }

    $.await.done('getRastreamentoHistorico')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.rastreamentoHistorico.persistRastreamentoHistorico()
    await Helper.successAndPush(
      'system.success.persist',
      '/rastreamento-historico/list'
    )
  }
}
